class Cumulo {
    onEnter() {
        // code to be executed when the home renderer is entered
    }
    onEnterCompleted() {
        // code to be executed after the home renderer has been fully entered
    }
}

export default Cumulo;